export function addUtmParams(url, productName) {
  if (!url) return url;
  try {
    const u = new URL(url);
    u.searchParams.set("utm_source", "shaft-quiz");
    u.searchParams.set("utm_medium", "referral");
    u.searchParams.set("utm_campaign", "shaft-recommendation");
    if (productName) {
      const slug = productName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 80);
      u.searchParams.set("utm_content", slug);
    }
    return u.toString();
  } catch {
    return url;
  }
}
